import { Card } from '@app/components/various/Card';

export const CheckoutSplitCardSkeleton = () => (
  <Card.Wrapper>
    <Card.Header isLoading />
    <Card.Title isLoading />
    <Card.AttributeList isLoading skeletonRows={3} />
    <Card.SummaryList isLoading skeletonRows={1} />
  </Card.Wrapper>
);
